// The app-wide cache of the visitor's country, as guessed by
// GET References/country/code.
//
// Extracted from helpers/index.ts so modules that must stay dependency-free can
// share the SAME localStorage variable instead of keeping a second copy of the
// same fact: helpers/index.ts imports ../i18n and cwb-react, which drags an
// i18next boot into anything that touches it (see persistedFlow.ts for the same
// constraint). helpers/index.ts re-exports these four, so all ~30 existing call
// sites are unchanged and there is still exactly one definition of the keys.
//
// Written by referencesModel.setRequesterCountryCode / setForceRequesterCountryCode
// and premiumModel; read by the actor, agent, talent, casting and CWBLabs
// signups for trial eligibility and phone/region defaults — and now by the
// submission flow, so whichever funnel looks the country up first spares the
// others the round trip.
//
// No expiry, deliberately: the value already decides trial eligibility for
// every other funnel with no expiry, and two different staleness rules for one
// fact is worse than one. It lives until cleanCache() or localStorage.clear().
// If a TTL is ever wanted it belongs HERE, so every funnel gets it at once.

const COUNTRY_KEY = "CountryCode";
const REGION_KEY = "RegionCode";

export const setCountryCode = (code: string) => {
  localStorage.setItem(COUNTRY_KEY, code);
};

export const getCountryCode = () => {
  return localStorage.getItem(COUNTRY_KEY);
};

export const setRegionCode = (code: string) => {
  localStorage.setItem(REGION_KEY, code);
};

export const getRegionCode = () => {
  return localStorage.getItem(REGION_KEY);
};
